import { Configuration, DefaultApi } from "../services/openapi";

const configuration = new Configuration({
  basePath: process.env.REACT_APP_API_URL,
});

export const api = new DefaultApi(configuration);
